import { ZoneContextManager } from '@opentelemetry/context-zone';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { browserDetector } from '@opentelemetry/opentelemetry-browser-detector';
import { Resource, browserDetector as baseBrowserDetector, detectResourcesSync, } from '@opentelemetry/resources';
import { BatchSpanProcessor, ParentBasedSampler, RandomIdGenerator, TraceIdRatioBasedSampler, WebTracerProvider, } from '@opentelemetry/sdk-trace-web';
import { SemanticResourceAttributes } from '@opentelemetry/semantic-conventions';
export const idGenerator = new RandomIdGenerator();
export async function createWebTracer(serviceName) {
    var _a;
    const release = 
    // @ts-expect-error: COMMIT_SHA is injected by webpack
    'NO_COMMIT' !== COMMIT_SHA ? COMMIT_SHA : undefined;
    const { environment } = await import('folio-common-web-utils');
    const detectedResources = detectResourcesSync({
        detectors: [baseBrowserDetector, browserDetector],
    });
    await ((_a = detectedResources.waitForAsyncAttributes) === null || _a === void 0 ? void 0 : _a.call(detectedResources));
    let resource = Resource.default()
        .merge(detectedResources)
        .merge(new Resource({
        [SemanticResourceAttributes.DEPLOYMENT_ENVIRONMENT]: environment,
        [SemanticResourceAttributes.SERVICE_NAME]: serviceName,
    }));
    if (release) {
        // non-standard, but useful
        resource = resource.merge(new Resource({ COMMIT_SHA: release }));
    }
    const provider = new WebTracerProvider({
        idGenerator,
        sampler: new ParentBasedSampler({
            // TODO: lower this to 0.1 (or something) once we have more confidence in the tracing
            root: new TraceIdRatioBasedSampler(1),
        }),
        resource,
    });
    const url = new URL(window.location.pathname.startsWith('/stiftemaskinen')
        ? '/stiftemaskinen/traces'
        : '/traces', window.location.href).href;
    provider.addSpanProcessor(new BatchSpanProcessor(new OTLPTraceExporter({ url })));
    provider.register({
        contextManager: new ZoneContextManager(),
    });
    // Registering instrumentations
    registerInstrumentations({
        instrumentations: [
            // these might cause a document load to be the base context for everything
            // on a page, which means every thing that happens belongs to the same
            // trace.
            // We should investigate how to solve this as the spans are useful.
            // https://github.com/open-telemetry/opentelemetry-js-contrib/issues/1368#issuecomment-1424490490
            // new DocumentLoadInstrumentation(),
            // new UserInteractionInstrumentation(),
            new FetchInstrumentation(),
            new XMLHttpRequestInstrumentation(),
        ],
    });
    provider.getTracer(serviceName);
}
//# sourceMappingURL=index.js.map